"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetStxSupplyResponseToJSON = exports.GetStxSupplyResponseFromJSONTyped = exports.GetStxSupplyResponseFromJSON = void 0;
function GetStxSupplyResponseFromJSON(json) {
    return GetStxSupplyResponseFromJSONTyped(json, false);
}
exports.GetStxSupplyResponseFromJSON = GetStxSupplyResponseFromJSON;
function GetStxSupplyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'unlocked_percent': json['unlocked_percent'],
        'total_stx': json['total_stx'],
        'unlocked_stx': json['unlocked_stx'],
        'block_height': json['block_height'],
    };
}
exports.GetStxSupplyResponseFromJSONTyped = GetStxSupplyResponseFromJSONTyped;
function GetStxSupplyResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'unlocked_percent': value.unlocked_percent,
        'total_stx': value.total_stx,
        'unlocked_stx': value.unlocked_stx,
        'block_height': value.block_height,
    };
}
exports.GetStxSupplyResponseToJSON = GetStxSupplyResponseToJSON;
//# sourceMappingURL=GetStxSupplyResponse.js.map